import { cn } from '../../lib/utils'

export default function Spinner({ size = 'md', className, label = 'Chargement' }) {
  const sizes = { sm: 'h-4 w-4', md: 'h-6 w-6', lg: 'h-10 w-10' }
  return (
    <svg className={cn('animate-spin text-primary', sizes[size], className)} viewBox="0 0 24 24" role="status" aria-label={label}>
      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
    </svg>
  )
}
